export default {
    /**
     * Enabled config path
     */
    XML_PATH_FPT_ENABLED: 'tax/weee/enable',

    /*display settings*/
    XML_PATH_FPT_DISPLAY_PRODUCT_VIEW: 'tax/weee/display',

    XML_PATH_FPT_DISPLAY_PRODUCT_LIST: 'tax/weee/display_list',

    XML_PATH_FPT_DISPLAY_SALES: 'tax/weee/display_sales',

    XML_PATH_FPT_DISPLAY_EMAIL: 'tax/weee/display_email',

    XML_PATH_FPT_INCLUDE_IN_SUBTOTAL: 'tax/weee/include_in_subtotal',

    XML_PATH_FPT_TAXABLE: 'tax/weee/apply_vat',

    XML_PATH_POS_FPT_DISPLAY_PRODUCT_PRICE: 'webpos/tax_configuration/fpt/product_price',

    XML_PATH_POS_FPT_INCLUDE_IN_SUBTOTAL: 'webpos/tax_configuration/fpt/include_in_subtotal',
}


// WEBPACK FOOTER //
// ./src/view/constant/weee/ConfigConstant.js